import React, { useState } from "react";
import Mangnifer from "../assets/images/Magnifier.svg";

import AdvisorCard from "../components/Advisors/AdvisorCard";
import { useGetAdvisorsQuery } from "../store/api/advisorsApi";
import { useGetSubscriptionStatusQuery } from "../store/api/tradingApi";
import Loader from "../components/Loader";
import infoCircle from "../assets/images/info-circle.svg";

const Advisors = () => {
  const { data: advisorsData = [], isLoading, error } = useGetAdvisorsQuery();
  const { data: subscriptionStatus = [] } = useGetSubscriptionStatusQuery();
  const [searchTerm, setSearchTerm] = useState("");

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    console.error("Advisors error:", error);
    return <div>Error loading advisors</div>;
  }

  return (
    <div className="min-h-screen bg-[#f5f7fa] p-4 lg:p-6">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex items-center gap-3 bg-[#5a5a5a] rounded-lg p-3 lg:p-4 mb-4 lg:mb-6">
          <img
            src={infoCircle}
            alt="info"
            className="w-5 h-5 lg:w-6 lg:h-6 flex-shrink-0 brightness-0 invert"
          />
          <div className="flex items-center">
            <span className="text-sm lg:text-base text-white">
              Select an advisor you wish to take trading calls from, for the
              free trial of 1 month. Maximum 2 allowed.
            </span>
          </div>
        </div>

        <div className="mb-4 lg:mb-6 bg-white p-6 rounded-lg">
          <h2 className="text-xl lg:text-[24px] font-semibold text-[#454545] mb-2">
            My Advisors({advisorsData?.length || 0})
          </h2>
          <p className="text-sm lg:text-base text-gray-500 mb-4 lg:mb-6"></p>

          <div className="flex flex-col sm:flex-row gap-3 lg:gap-4">
            <div className="flex-1">
              <input
                type="text"
                className="w-full px-4 py-2.5 lg:py-3 pl-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm lg:text-base bg-white"
                placeholder="Search"
                style={{
                  backgroundImage: `url(${Mangnifer})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "16px center",
                  backgroundSize: "18px 18px",
                }}
                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              />
            </div>

            {/* <Select
              suffixIcon={<img src={downArrow} alt="dropdown" />}
              className="w-full sm:w-[180px] lg:w-[200px]"
              placeholder="Sort by"
              size="large"
              options={[
                { value: "rating", label: "Rating" },
                { value: "experience", label: "Experience" },
                { value: "success", label: "Success Rate" },
              ]}
            /> */}
          </div>
        </div>

        <div className="flex flex-col">
          {advisorsData
            ?.filter((advisor) => {
              if (!searchTerm) return true;
              return advisor?.firstName?.toLowerCase()?.includes(searchTerm);
            })
            ?.map((a, i) => {
              const isSubscribed = subscriptionStatus.some((sub) => {
                const subId = String(sub.advisorId).trim().toLowerCase();
                const advisorId = String(a.id).trim().toLowerCase();
                return (
                  subId === advisorId &&
                  (!sub.expiryAt || new Date(sub.expiryAt) > new Date())
                );
              });

              return (
                <AdvisorCard
                  key={i}
                  firstName={a?.firstName}
                  lastName={a?.lastName}
                  sebiRegistrationNumber={a?.sebiRegistrationNumber}
                  successRate={a?.advisorMetrics?.successRate}
                  recommendationCount={a?.advisorMetrics?.recommendationCount}
                  roi={a?.advisorMetrics?.roi}
                  liveCalls={a?.advisorMetrics?.liveCalls}
                  accuracy={a?.advisorMetrics?.accuracy}
                  experience={a?.experience}
                  userId={a?.id}
                  isSubscribed={isSubscribed}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Advisors;
